import { emailRegEx } from 'ecs-react-components/dist/index.es';

export const validations = {
  userEmail: {
    required: true,
    validateOnBlur: false,
    minLength: 5,
    promise: (fieldName, fieldValue) =>
      (new Promise((resolve, reject) => {
        if (fieldValue && !emailRegEx.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })),
  },
};
